/**
 * Todos los textos de la interfaz, en un único fichero (§9).
 *
 * La aplicación es solo en español. Centralizarlos aquí no es
 * internacionalización: es para que añadir otro idioma más adelante no obligue a
 * tocar los componentes, que es exactamente lo que pide el documento.
 */
export const textos = {
  aplicacion: {
    titulo: 'Citas de soporte',
    subtitulo: 'Reserva una llamada con un agente especializado.',
    tituloImpacto: 'El soporte que necesitas, cuando lo necesitas.',
    subtituloImpacto:
      'Reserva una llamada con un especialista que conoce tu software y llega preparado para ayudarte.',
    especialistasDisponibles: 'Especialistas disponibles para ayudarte',
    proximaCita: 'Tu próxima cita',
    especialistaSoftware: 'Un especialista en tu software',
    reservaEnMinutos: 'Elige el momento que mejor te venga',
    areaCliente: 'Área de cliente',
    marcaSeleccionada: 'Marca seleccionada',
    identificacionSegura: 'Identificación segura de cliente',
    portal: 'Portal de soporte',
    asistencia: 'Asistencia personalizada',
    tuReserva: 'Tu reserva',
    paso: 'Paso',
    de: 'de',
    misCitas: 'Mis citas',
    volver: 'Volver',
    salir: 'Cerrar sesión',
    cargando: 'Cargando…',
    reintentar: 'Reintentar',
    saltarAlContenido: 'Saltar al contenido principal',
    soporte: 'Centro de soporte',
    privacidad: 'Privacidad',
    pie: 'TeamSystem España · Atención especializada para nuestros clientes.',
    garantiasAria: 'Características del servicio de citas',
    accesoSeguro: 'Acceso protegido',
    accesoSeguroDetalle: 'Código de un solo uso',
    horarioLocal: 'Horario de Madrid',
    horarioLocalDetalle: 'Una referencia para todas las citas',
    confirmacionCorreo: 'Confirmación inmediata',
    confirmacionCorreoDetalle: 'Aviso y calendario por correo',
  },

  pasos: {
    entidad: 'Marca',
    acceso: 'Acceso',
    servicio: 'Servicio',
    hora: 'Hora',
    confirmacion: 'Confirmación',
  },

  entidad: {
    titulo: '¿Con qué marca quieres hablar?',
    ayuda: 'Elige la marca con la que tienes contratado el soporte.',
    buscar: 'Buscar una marca',
    buscarPlaceholder: 'Nombre o código de marca',
    sinResultados: 'No encontramos ninguna marca',
    sinResultadosAyuda: 'Prueba con otro nombre o código.',
    ninguna: 'No hay marcas disponibles',
    ningunaAyuda: 'Vuelve a intentarlo en unos minutos.',
  },

  acceso: {
    titulo: 'Identifícate',
    ayuda: 'Los dos datos aparecen en cualquiera de tus facturas.',
    nif: 'NIF o CIF',
    nifAyuda: 'Por ejemplo, B12345678.',
    numeroCliente: 'Código de cliente',
    numeroClienteAyuda: 'El que aparece en tus facturas y zona privada.',
    entrar: 'Continuar',
    codigoTitulo: 'Revisa tu correo',
    codigoAyuda: (pista: string) =>
      `Hemos enviado un código de 6 dígitos a ${pista}. Caduca en 10 minutos.`,
    codigoNota:
      'Lo enviamos siempre al correo que consta en tu ficha, nunca a uno que escribas aquí.',
    codigoTituloTelefono: 'Escribe el código',
    codigoAyudaTelefono:
      'Escribe el código de 6 dígitos que te ha dado nuestro agente por teléfono. Caduca en 10 minutos.',
    codigoNotaTelefono: 'El que te acaban de leer por teléfono, no uno que llegue por correo.',
    codigo: 'Código de acceso',
    verificar: 'Entrar',
    otroCodigo: 'Empezar de nuevo',
    recordado: 'Reconocemos este equipo, así que no te pedimos el código.',
    sinSoporteTitulo: 'Necesitas soporte contratado',
    contratar: 'Contratar el soporte',
    sinCorreoTitulo: 'Tu ficha no tiene correo',
  },

  servicio: {
    titulo: '¿Sobre qué software necesitas ayuda?',
    ayuda: 'Solo aparecen los servicios que tienes contratados.',
    sinServicios:
      'No tienes ningún servicio contratado en esta marca. Si crees que es un error, llama al soporte.',
    buscar: 'Buscar software',
    buscarPlaceholder: 'Nombre o código del software',
    sinResultados: 'No encontramos ese software',
    sinResultadosAyuda: 'Prueba con otro nombre o código.',
    duracion: (minutos: number) => `Llamada de ${minutos} minutos`,
  },

  hora: {
    titulo: 'Elige día y hora',
    zonaHoraria: 'Horas en',
    avisoZonaTitulo: 'Horario de Madrid',
    avisoZonaDetalle:
      'La cita se realizará según el horario de Madrid. Todas las horas mostradas corresponden a esta zona horaria.',
    disponibilidad: 'Disponibilidad',
    diasDisponibles: 'Días con citas disponibles',
    verDia: (fecha: string) => `Ver las horas disponibles del ${fecha}`,
    huecosDisponibles: (cantidad: number) =>
      cantidad === 1 ? '1 hora libre' : `${cantidad} horas libres`,
    eligeUnaHora: 'Selecciona una hora',
    eligeUnaHoraAyuda: 'Elige el horario que mejor te venga.',
    sinHuecos: 'No hay huecos libres en estos días. Prueba con la semana siguiente.',
    sinHuecosTitulo: 'No hay citas disponibles esta semana',
    semanaAnterior: 'Semana anterior',
    semanaSiguiente: 'Semana siguiente',
    huecosDe: (fecha: string) => `Huecos del ${fecha}`,
    elegirHora: (hora: string, fecha: string) => `Reservar el ${fecha} a las ${hora}`,
  },

  confirmacion: {
    titulo: 'Confirma la cita',
    datosContacto: 'Datos de contacto',
    datosContactoAyuda: 'Indica con quién debe contactar el especialista.',
    avisosCorreo: 'Avisos por correo',
    avisosCorreoAyuda: 'Puedes incluir hasta cinco destinatarios.',
    detalleConsulta: 'Tu consulta',
    detalleConsultaAyuda: 'Ayúdanos a preparar la llamada antes de contactar contigo.',
    contactoNombre: 'Persona a la que llamamos',
    contactoNombreAyuda: 'El agente preguntará por esta persona.',
    contactoTelefono: 'Teléfono de contacto',
    contactoTelefonoAyuda: 'El número al que llamaremos a esa hora.',
    contactoEmail: 'Correo para los avisos',
    contactoEmailAyuda:
      'Enviaremos la confirmación y los recordatorios a todas las direcciones indicadas.',
    contactoEmailAdicional: (numero: number) => `Correo adicional ${numero}`,
    contactoEmailRepetido: 'Este correo ya está incluido.',
    anadirCorreo: 'Añadir otro correo',
    quitarCorreo: 'Quitar correo',
    motivo: 'Motivo de la consulta',
    contadorMotivo: (actual: number, maximo: number) => `${actual} / ${maximo} caracteres`,
    motivoAyuda: (minimo: number) =>
      `Cuéntanos qué te pasa, con al menos ${minimo} caracteres. Cuanto más concreto, mejor preparado acudirá el agente.`,
    duracion: (minutos: number) => `La llamada dura ${minutos} minutos.`,
    preparacion: 'Es indispensable que tengas a mano la información que quieras consultar.',
    cupoAgotado: (limite: number) =>
      `Ya has usado las ${limite} citas del mes de la fecha elegida. Elige otro mes o cancela una cita de ese mes.`,
    reservar: 'Confirmar la cita',
    reservando: 'Reservando…',
    conflicto:
      'Ese hueco acaba de ocuparse. Hemos actualizado la agenda: elige otra hora, marcada abajo.',
  },

  reserva: {
    titulo: 'Cita confirmada',
    descargarIcs: 'Añadir a mi calendario',
    verMisCitas: 'Ver mis citas',
    otraCita: 'Reservar otra cita',
    completada: 'Reserva completada correctamente',
    consultandoCupo: 'Consultando las citas disponibles…',
    errorCupo: 'No hemos podido consultar cuántas citas quedan disponibles.',
    cupoRestante: (restantes: number, mes: string) =>
      restantes === 1
        ? `Te queda 1 cita disponible para ${mes}.`
        : `Te quedan ${restantes} citas disponibles para ${mes}.`,
    cupoSinLimite: (mes: string) => `No tienes límite de citas para ${mes}.`,
  },

  misCitas: {
    titulo: 'Mis citas',
    ayuda: 'Aquí están las citas de tu empresa en esta marca, las próximas y las ya pasadas.',
    cupoTitulo: 'Citas disponibles este mes',
    cupoCantidad: (restantes: number, limite: number) =>
      `${restantes} de ${limite} citas disponibles este mes`,
    proximas: 'Próximas',
    pasadas: 'Anteriores',
    ninguna: 'Todavía no tienes ninguna cita.',
    ningunaAyuda: 'Cuando reserves una llamada, aparecerá aquí con todos sus detalles.',
    cancelar: 'Cancelar',
    cancelando: 'Cancelando…',
    reprogramar: 'Cambiar la hora',
    confirmarCancelacion: '¿Seguro que quieres cancelar esta cita?',
    confirmarCancelacionAyuda:
      'El hueco volverá a quedar disponible y esta acción no se puede deshacer.',
    mantener: 'Mantener la cita',
    confirmarCancelar: 'Sí, cancelar la cita',
    fueraDePlazo: (minutos: number) =>
      `Faltan menos de ${minutos} minutos: para cambiarla o cancelarla, llama al soporte por teléfono.`,
    estados: {
      confirmada: 'Confirmada',
      reprogramada: 'Reprogramada',
      cancelada: 'Cancelada',
      atendida: 'Atendida',
      no_presentado: 'No presentado',
    } as Record<string, string>,
    nuevaCita: 'Reservar una cita',
    motivoEtiqueta: 'Consulta',
    verProximas: 'Ver citas próximas',
    verAnteriores: 'Ver citas anteriores',
    sinProximas: 'No hay citas próximas.',
    sinProximasAyuda: 'Cuando reserves una nueva cita, aparecerá en esta sección.',
    sinAnteriores: 'Todavía no hay citas anteriores.',
    sinAnterioresAyuda: 'El historial aparecerá aquí después de tus primeras citas.',
    canceladaCorrectamente: 'La cita se ha cancelado correctamente.',
    reprogramadaCorrectamente: 'La cita se ha cambiado de hora correctamente.',
    cerrarAviso: 'Cerrar aviso',
  },

  errores: {
    generico: 'Algo ha ido mal. Inténtalo otra vez en un momento.',
    sinConexion: 'No hemos podido contactar con el servidor. Revisa tu conexión.',
    sesionCaducada: 'Tu sesión ha caducado. Vuelve a identificarte.',
  },

  resumenReserva: {
    etiqueta: 'Tu selección',
    titulo: 'Resumen de la cita',
    entidad: 'Marca',
    servicio: 'Servicio',
    duracion: 'Duración',
    cuando: 'Fecha y hora',
    porElegir: 'Pendiente de elegir',
    minutos: (minutos: number) => `${minutos} minutos`,
  },
} as const;
